import { CoachTodo } from "../../types/coachTodos"
import { createJoonAPIClient } from "../../util/joon-api"

/**
 * Params:
 * - client_id: int | null | undefined (if you want to filter by specific client todos)
 * - coach_id: int | null | undefined (if you want to filter by which coach. This is helpful for supervisor users because this endpoint will also return all direct report's todos too. Filter by user's id if only want their todos)
 */
export const getCoachTodos = async (params?: {
  clientId?: number
  coachId?: number
}) => {
  const API = createJoonAPIClient()
  const response = await API.get<{ results: CoachTodo[] }>(
    "/api/coach-todos/",
    {
      params: {
        client_id: params?.clientId,
        coach_id: params?.coachId,
      },
    }
  )
  return response.data.results
}

export const markCoachTodoAsComplete = async ({
  todoId,
}: {
  todoId: number
}) => {
  const API = createJoonAPIClient()
  return API.post(`/api/coach-todos/${todoId}/mark-complete/`)
}
